module.exports = __webpack_public_path__ + "img/emp-token.1eb28877.svg";